import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getBoldedText from "@insite/client-framework/Common/Utilities/getPatternBolded";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Icon, { IconPresentationProps, IconProps } from "@insite/mobius/Icon";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";

import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { useState, useEffect, useRef, useCallback, useContext } from "react";
import debounce from "lodash/debounce";
import { css, ThemeProps } from "styled-components";
import Plus from "@insite/mobius/Icons/Plus";
import Minus from "@insite/mobius/Icons/Minus";
import Search from "@insite/mobius/Icons/Search";
import Menu from "@insite/mobius/Icons/Menu";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";

import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import {
    getCategoriesDataView,
    getSubCategoryIds,
} from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import { connect, ResolveThunks } from "react-redux";
import { emptyGuid } from "@insite/client-framework/Common/StringHelpers";

import loadCategories from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategories";
import loadCategoriesCustom from "@tCentro/Handlers/CENTaxonomyCatHandler";
import postTaxonomyData from "@tCentro/Handlers/CENTaxonomyCatHandler";
import addTaxonomyCatHandler, {
    getTaxonomyCategoryByIdHandler,
    getTaxonomyRecommendationHandler,
    patchTaxonomyCategoryHandler,
} from "@tCentro/Handlers/CENAddTaxonomyCatHandler";
import exportTaxonomyHandler from "@tCentro/Handlers/CENTaxonomyExportHandler";
import { TaxonomyRecommendationModel } from "@tCentro/Services/CENTaxonomyAddCatService";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell, { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import setDrawerIsOpen from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetDrawerIsOpen";
import CENTaxonomyArrowUp from "@tCentro/Icons/CENTaxonomyArrowUp";
import CENTaxonomySearchIcon from "@tCentro/Icons/CENTaxonomySearchIcon";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import CENTaxonomyTwoLineMenu from "@tCentro/Icons/CENTaxonomyTwoLineMenu";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { get } from "@insite/client-framework/Services/ApiService";
import exportTaxonomyRecommendationHandler from "@tCentro/Handlers/CENTaxonomyExportHandler";
import CENTaxonomyArrowDown from "@tCentro/Icons/CENTaxonomyArrowDown";
import ToasterContext from "@tCentro/MobiusOverrides/Toast/ToasterContext";
import siteMessage from "@insite/client-framework/SiteMessage";

interface SelectedCategory {
    id: string;
    targetTaxonomyName: string;
}
const mapStateToProps = (state: ApplicationState) => {
    const getCategoriesParameter = {
        maxDepth: 7,
        includeStartCategory: false,
    };

    return {
        getCategoriesParameter,
        categoriesDataView: getCategoriesDataView(state, getCategoriesParameter),
        topLevelCategoryIds: getSubCategoryIds(state, emptyGuid),
        language: state.context.session.language,
        session: getSession(state),
    };
};

const mapDispatchToProps = {
    postTaxonomyData,
    addTaxonomyCatHandler,
    getTaxonomyRecommendationHandler,
    getTaxonomyCategoryByIdHandler,
    patchTaxonomyCategoryHandler,
    exportTaxonomyHandler,
    exportTaxonomyRecommendationHandler,
};

type Props = WidgetProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    ThemeProps<BaseTheme>;
export interface CategorySelectorStyles {
    serachWrapper?: InjectableCss;
    mainContainer?: InjectableCss;
    pageTitle?: TypographyPresentationProps;
    pageTitleCustom?: TypographyPresentationProps;
    pageSubtitle?: TypographyPresentationProps;
    sectionContainer?: InjectableCss;
    sectionContainerTwo?: InjectableCss;
    headerSection?: InjectableCss;
    headerNumber?: TypographyPresentationProps;
    headerTitle?: TypographyPresentationProps;
    headerTitleCustom?: TypographyPresentationProps;
    selectCategoryButton?: ButtonPresentationProps;
    selectedCategoryBox?: InjectableCss;
    selectedCategoryText?: TypographyPresentationProps;
    changeButton?: ButtonPresentationProps;
    breadcrumbText?: TypographyPresentationProps;
    gridContainer?: InjectableCss;
    panelContainer?: InjectableCss;
    panelHeader?: InjectableCss;
    panelHeaderTwo?: InjectableCss;
    panelTitle?: InjectableCss;
    searchField?: TextFieldPresentationProps;
    categoryListContainer?: InjectableCss;
    categoryItem?: InjectableCss;
    categoryToggleButton?: InjectableCss;
    categoryName?: TypographyPresentationProps;
    categoryNameCustom?: LinkPresentationProps;
    addButton?: ButtonPresentationProps;
    countBox?: InjectableCss;
    countText?: TypographyPresentationProps;
    selectedCategoryItem?: InjectableCss;
    dragHandle?: InjectableCss;
    removeButton?: ButtonPresentationProps;
    footerButtons?: InjectableCss;
    cancelButton?: ButtonPresentationProps;
    saveButton?: ButtonPresentationProps;
    dataTable?: DataTableProps;
    srNoHeader?: DataTableHeaderProps;
    sourceCategoryNameHeader?: DataTableHeaderProps;
    relatedCategoriesHeader?: DataTableHeaderProps;
    relatedCategoriesCells?: DataTableCellProps;
    modifiedByHeader?: DataTableHeaderProps;
    modifiedOnHeader?: DataTableHeaderProps;
    createdByHeader?: DataTableHeaderProps;
    createdOnHeader?: DataTableHeaderProps;
    addHeader?: DataTableHeaderProps;
    editHeader?: DataTableHeaderProps;
    srNoCells?: DataTableCellProps;
    sourceCategoryNameCells?: DataTableCellProps;
    modifiedByCells?: DataTableCellProps;
    modifiedOnCells?: DataTableCellProps;
    createdByCells?: DataTableCellProps;
    createdOnCells?: DataTableCellProps;
    addCells?: DataTableCellProps;
    editCells?: DataTableCellProps;
    spinner?: LoadingSpinnerProps;
    sortIconSources: {
        sortable: string;
        ascending: string;
        descending: string;
        none: string;
        other: string;
    };
    centeringWrapper?: InjectableCss;
    icon?: IconProps;
    iconTwo?: IconProps;
    tableScrollWrapper?: InjectableCss;
    noCategoryWrapper?: InjectableCss;
    noCategoryText?: InjectableCss;
    headerSectionWrapper?: InjectableCss;
    headerSubHeading?: InjectableCss;
    headerDescription?: InjectableCss;
    searchMsg?: InjectableCss;
}

export const categorySelectorStyles: CategorySelectorStyles = {
    headerDescription: {
        css: css`
            font-size: 14px;
            margin: 16px 0px;
        `,
    },
    searchMsg: {
        css: css`
            font-size: 10px;
            margin: 16px 0px;
        `,
    },
    editHeader: {
        css: css`
            min-width: 125px;
        `,
    },
    pageTitleCustom: {
        css: css`
            font-family: Poppins;
            font-weight: 600;
            font-style: SemiBold;
            font-size: 16px;
            leading-trim: NONE;
            line-height: 24px;
            letter-spacing: 0%;
            padding-bottom: 8px;
            color: ${COLORS.black};
        `,
    },
    headerSectionWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    headerSubHeading: {
        css: css`
            display: flex;
            flex-direction: row;
        `,
    },
    noCategoryWrapper: {
        css: css`
            text-align: center;
            margin-top: 64px;
            margin-left: auto;
            margin-right: auto;
        `,
    },
    noCategoryText: {
        css: css`
            font-size: 14px;
            line-height: 24px;
            color: #262525;
        `,
    },
    tableScrollWrapper: {
        css: css`
            @media (max-width: 1280px) {
                width: 100%;
                overflow-x: hidden;
                overflow-y: hidden;
                -webkit-overflow-scrolling: touch;
                table {
                    min-width: 900px;
                }
            }
        `,
    },
    serachWrapper: {
        css: css`
            display: flex;
            width: 50%;
            > div {
                > div {
                    input {
                        border-radius: 20px !important;
                    }
                }
            }
            @media (max-width: 768px) {
                width: 100%;
            }
        `,
    },
    iconTwo: {
        css: css`
            width: 24px !important;
            height: 24px !important;
            padding: 0px !important;
            top: 12px !important;
            right: 26px !important;
            pointer-events: auto !important;
            cursor: pointer !important;
            svg {
                width: 24px;
                height: 24px;
            }
        `,
    },
    icon: {
        css: css`
            top: 5px !important;
            right: 16px !important;
            cursor: pointer;
            pointer-events: auto !important;
        `,
    },
    centeringWrapper: {
        css: css`
            height: 100px;
            width: 100%;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: 0 auto;
        `,
    },
    srNoCells: {
        typographyProps: {
            ellipsis: true,
        },
        css: css`
            display: inline-block;
            max-width: 85px;
            width: 100%;
        `,
    },
    sourceCategoryNameCells: {
        typographyProps: {
            ellipsis: true,
        },
        css: css`
            padding: 10px !important;
        `,
    },
    modifiedByCells: { css: css`` },
    modifiedOnCells: { css: css`` },
    createdByCells: { css: css`` },
    createdOnCells: { css: css`` },
    addCells: { css: css`` },
    editCells: {
        css: css`
            padding: 0px !important;
        `,
    },
    mainContainer: { css: css`` },
    pageTitle: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-size: 40px;
            line-height: 48px;
            font-weight: ${TYPOGRAPHY.weight.black};
            color: ${COLORS.black};
        `,
    },
    pageSubtitle: {
        css: css`
            font-size: ${TYPOGRAPHY.size.largest};
            line-height: 32px;
            color: ${COLORS.black};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
        `,
    },
    sectionContainer: {
        css: css`
            background-color: ${COLORS.white};
            padding: 0px;
            margin-bottom: 48px;
            display: flex;
            flex-direction: column;
            gap: 8px;
        `,
    },
    sectionContainerTwo: {
        css: css`
            background-color: ${COLORS.white};
            padding: 0px;
            margin-bottom: 0px;
        `,
    },
    selectCategoryButton: {
        buttonType: "outline",
        css: css`
            width: 100%;
            border-radius: 0px !important;
            padding: 33px 23px;
            border: 1px solid #eef3f0;
            background-color: #eef3f0;
            color: ${COLORS.black};
            font-size: ${TYPOGRAPHY.size.large};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            line-height: 24px;
            text-align: left;
            display: flex;
            gap: 2px;
            align-items: center;
            outline: none !important;
            &:hover {
                background-color: #eef3f0;
                color: ${COLORS.black} !important;
                border: 1px solid #eef3f0;
                border-color: #eef3f0 !important;
            }
            &:active {
                border: 1px solid #eef3f0;
                color: ${COLORS.black} !important;
            }
            &:focus {
                outline: none !important;
            }
            &:focus-visible {
                outline: none !important;
            }
        `,
    },
    headerSection: {
        css: css`
            display: flex;
            justify-content: space-between;
            background-color: #eef3f0;
            border: 4px solid #eef3f0;
            padding: 20px;
            margin-bottom: 48px;
            align-items: center;
        `,
    },
    headerNumber: {
        css: css`
            font-size: ${TYPOGRAPHY.size.large};
            line-height: 24px;
            color: ${getColor("primary")};
            margin-right: 10px;
            background-color: #eef3f0;
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            padding: 8px;
            border-radius: 100%;
            width: 32px;
            height: 32px;
            display: flex;
            justify-content: center;
            align-items: center;
        `,
    },
    headerTitle: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-size: ${TYPOGRAPHY.size.large};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            line-height: 24px;
            color: ${COLORS.black};
        `,
    },
    headerTitleCustom: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-size: ${TYPOGRAPHY.size.large};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            line-height: 24px;
            color: ${COLORS.black};
            display: flex;
            align-items: center;
        `,
    },
    selectedCategoryBox: {
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
        `,
    },
    selectedCategoryText: {
        css: css`
            display: flex;
            font-size: ${TYPOGRAPHY.size.large};
            color: ${COLORS.black};
            margin-right: 2px;
            font-weight: 600;
            line-height: 24px;
        `,
    },
    changeButton: {
        size: 32,
        buttonType: "outline",
        color: "secondary",
        css: css`
            border: 2px solid ${getColor("secondary")};
            color: ${getColor("secondary")};
            font-size: 14px;
            line-height: 16px;
            padding: 6px 14px;
            height: auto;
            background-color: #fff;
            border-radius: 16px;
        `,
    },
    breadcrumbText: {
        css: css`
            font-size: 12px;
            color: #636161;
            font-weight: 600;
            line-height: 16px;
            margin-top: 4px;
        `,
    },
    gridContainer: {
        css: css`
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 24px;
            @media (max-width: 768px) {
                grid-template-columns: 1fr;
            }
        `,
    },
    panelContainer: {
        css: css`
            overflow-y: auto;
            border: 4px solid #eef3f0;
        `,
    },
    panelHeader: {
        css: css`
            padding: 24px 24px 23px 24px;
            border-bottom: 1px solid #e0dfe0;
            background-color: #eef3f0;
            input {
                padding: 12px 24px;
                font-size: 14px;
                line-height: 24px;
                font-weight: 400;
                border: none;
                height: auto !important;
            }
        `,
    },
    panelHeaderTwo: {
        css: css`
            padding: 36px 36px 35px 36px;
            border-bottom: 1px solid #e0dfe0;
            background-color: #eef3f0;
        `,
    },
    panelTitle: {
        css: css`
            display: flex;
            align-items: center;
            margin-bottom: 12px;
        `,
    },
    searchField: {
        cssOverrides: {
            formInputWrapper: css`
                && > input {
                    padding: 12px 24px !important;
                    font-size: 14px !important;
                    line-height: 24px;
                    font-weight: 400;
                    border: none !important;
                    height: auto !important;
                    border-radius: 32px !important;
                }
            `,
        },
    },
    categoryListContainer: {
        css: css`
            max-height: 491px;
            min-height: 491px;
            overflow-y: auto;
        `,
    },
    categoryItem: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 11.5px 12px;
            border-bottom: 1px solid #e0e0e0;
            &:hover {
                background-color: ${COLORS.background.grayShade};
            }
        `,
    },
    categoryToggleButton: {
        css: css`
            background: none;
            border: none;
            padding: 0;
            margin-right: 8px;
            cursor: pointer;
            color: #757575;
            display: flex;
            align-items: center;
            min-height: 24px !important;
            &:hover {
                background-color: transparent;
                border-color: transparent;
            }
            &:focus {
                outline: none;
            }
            &:active {
                background-color: transparent;
                border-color: transparent;
            }
        `,
    },
    categoryName: {
        css: css`
            font-size: ${TYPOGRAPHY.size.smaller};
            color: ${COLORS.black} !important;
            line-height: 24px;
        `,
    },
    categoryNameCustom: {
        css: css`
            font-size: ${TYPOGRAPHY.size.smaller};
            color: ${COLORS.black} !important;
            line-height: 24px;
            > span {
                border: 2px solid red;
            }
        `,
    },
    addButton: {
        size: 20,
        buttonType: "outline",
        color: "secondary",
        css: css`
            border: 2px solid ${getColor("secondary")};
            color: ${getColor("secondary")};
            font-size: 14px;
            line-height: 16px;
            padding: 2px 14px;
            height: auto;
            background-color: #fff;
            border-radius: 16px;
            font-weight: 600;
        `,
    },
    countBox: {
        css: css`
            background-color: ${COLORS.background.grayShade};
            padding: 8px 12px;
            border-radius: 4px;
            margin-left: 24px;
        `,
    },
    countText: {
        css: css`
            font-size: ${TYPOGRAPHY.size.smaller};
            color: ${getColor("text.main")};
        `,
    },
    selectedCategoryItem: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 12px;
            margin-bottom: 8px;
            background-color: ${COLORS.white};
            border: 1px solid #d1d1d1;
            border-radius: 4px;
            cursor: move;
            &:hover {
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            }
        `,
    },
    dragHandle: {
        css: css`
            margin-right: 8px;
            color: #636161;
            height: 16px;
        `,
    },
    removeButton: {
        size: 24,
        buttonType: "outline",
        color: "secondary",
        css: css`
            font-size: 12px;
            line-height: 16px;
            color: ${getColor("secondary")};
            border: 2px solid ${getColor("secondary")};
            padding: 2px 8px;
            font-weight: 600;
            border-radius: 16px;
            background: #fff;
        `,
    },
    footerButtons: {
        css: css`
            display: flex;
            justify-content: flex-end;
            gap: 12px;
            margin-top: 24px;
            margin-bottom: -36px;
            @media (max-width: 768px) {
                margin-bottom: 8px;
            }
            @media (min-width: 769px) and (max-width: 1024px) {
                margin-bottom: -18px;
            }
        `,
    },
    cancelButton: {
        css: css`
            font-size: ${TYPOGRAPHY.size.large};
            line-height: 24px;
            font-weight: 600;
            color: ${getColor("text.link")};
            background-color: transparent !important;
            border-color: transparent !important;
            outline: none !important;
        `,
    },
    saveButton: {
        css: css`
            font-size: 18px;
            line-height: 24px;
            color: #fff;
            border: 2px solid ${getColor("secondary")};
            padding: 10px 24px;
            font-weight: 600;
            border-radius: 24px;
            background: ${getColor("secondary")};
        `,
    },
    sortIconSources: {
        sortable: "ChevronsUpDown",
        ascending: "ChevronUp",
        descending: "ChevronDown",
        none: "Minus",
        other: "Activity",
    },
};

const styles = categorySelectorStyles;

// ─── DROPDOWN CATEGORY ITEM (top-level so React keeps stable identity) ────────
interface DropdownCategoryItemProps {
    category: any;
    level?: number;
    dropdownSearchTerm: string;
    expandedCategories: Set<string>;
    selectedSourceCategory: any;
    taxonomyRecommendationModels: any[];
    onToggle: (id: string) => void;
    onSelect: (category: any) => void;
    categoryMatchesSearch: (cat: any, search: string) => boolean;
    parentMatches?: boolean;
}

const DropdownCategoryItem = ({
    category,
    level = 0,
    dropdownSearchTerm,
    expandedCategories,
    selectedSourceCategory,
    taxonomyRecommendationModels,
    onToggle,
    onSelect,
    categoryMatchesSearch,
    parentMatches = false,
}: DropdownCategoryItemProps) => {
    const hasSubCategories = category.subCategories && category.subCategories.length > 0;
    const [isHovered, setIsHovered] = useState(false);

    // Show this node if: no search, parent matched (show all siblings), self matches, or a descendant matches
    const selfMatches =
        !dropdownSearchTerm.trim() || category.name.toLowerCase().includes(dropdownSearchTerm.toLowerCase());
    const descendantMatches = !selfMatches && categoryMatchesSearch(category, dropdownSearchTerm);
    if (!parentMatches && !selfMatches && !descendantMatches) return null;

    const isExpanded = expandedCategories.has(category.id);
    const isLeaf = !hasSubCategories;
    const isSelected = selectedSourceCategory && String(selectedSourceCategory.id) === String(category.id);
    const isAlreadyAdded = taxonomyRecommendationModels.some(
        (item: any) => String(item.sourceTaxonomyId) === String(category.id),
    );

    return (
        <>
            <StyledWrapper
                css={css`
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 11.5px 23.5px;
                    padding-left: ${level * 20 + 12}px;
                    border-bottom: 1px solid #e0e0e0;
                    &:hover {
                        cursor: default;
                        background-color: ${COLORS.background.grayShade};
                    }
                `}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <StyledWrapper
                    css={css`
                        display: flex;
                        align-items: center;
                        flex: 1;
                        cursor: ${hasSubCategories ? "pointer" : "default"};
                    `}
                    onClick={() => {
                        if (hasSubCategories) onToggle(category.id);
                    }}
                >
                    {hasSubCategories ? (
                        <Button {...styles.categoryToggleButton}>
                            <Icon src={isExpanded ? Minus : Plus} size={24} />
                        </Button>
                    ) : (
                        <span style={{ width: 14, marginRight: 8 }} />
                    )}
                    <Typography
                        {...styles.categoryName}
                        css={css`
                            font-size: ${TYPOGRAPHY.size.smaller};
                            color: ${COLORS.black} !important;
                            line-height: 24px;
                            font-weight: 400;
                        `}
                    >
                        {category.name}
                    </Typography>
                </StyledWrapper>

                {isSelected || isAlreadyAdded ? (
                    <Button
                        css={css`
                            font-size: 14px;
                            line-height: 16px;
                            color: #fff;
                            border: 2px solid ${getColor("secondary")};
                            padding: 6px 14px;
                            font-weight: 600;
                            border-radius: 16px;
                            background: ${getColor("secondary")};
                        `}
                        disabled
                    >
                        {translate("Selected")}
                    </Button>
                ) : (
                    <>
                        {isHovered && isLeaf && (
                            <Button
                                size={50}
                                buttonType="outline"
                                css={css`
                                    font-size: 14px;
                                    line-height: 16px;
                                    padding: 6px 14px;
                                    min-height: unset;
                                    height: auto;
                                    background-color: #ffffff;
                                    border: 2px solid ${getColor("secondary")};
                                    color: ${getColor("secondary")};
                                    border-radius: 16px;
                                    font-weight: 600;
                                `}
                                onClick={(e: React.MouseEvent) => {
                                    e.stopPropagation();
                                    onSelect(category);
                                }}
                            >
                                {translate("Select")}
                            </Button>
                        )}
                    </>
                )}
            </StyledWrapper>

            {hasSubCategories &&
                isExpanded &&
                category.subCategories.map((subCat: any) => (
                    <DropdownCategoryItem
                        key={subCat.id}
                        category={subCat}
                        level={level + 1}
                        dropdownSearchTerm={dropdownSearchTerm}
                        expandedCategories={expandedCategories}
                        selectedSourceCategory={selectedSourceCategory}
                        taxonomyRecommendationModels={taxonomyRecommendationModels}
                        onToggle={onToggle}
                        onSelect={onSelect}
                        categoryMatchesSearch={categoryMatchesSearch}
                        parentMatches={selfMatches}
                    />
                ))}
        </>
    );
};

// ─── MAIN CATEGORY ITEM (top-level so React keeps stable identity) ─────────────
interface CategoryItemProps {
    category: any;
    level?: number;
    searchTerm: string;
    expandedCategories: Set<string>;
    selectedCategories: { id: string; targetTaxonomyName: string }[];
    onToggle: (id: string) => void;
    onAdd: (category: any) => void;
    categoryMatchesSearch: (cat: any, search: string) => boolean;
    parentMatches?: boolean;
}

const CategoryItem = ({
    category,
    level = 0,
    searchTerm,
    expandedCategories,
    selectedCategories,
    onToggle,
    onAdd,
    categoryMatchesSearch,
    parentMatches = false,
}: CategoryItemProps) => {
    const hasChildren = category.subCategories && category.subCategories.length > 0;
    const [isHovered, setIsHovered] = useState(false);
    const [showAllBrands, setShowAllBrands] = useState(false); // ← ADD

    const selfMatches = !searchTerm.trim() || category.name.toLowerCase().includes(searchTerm.toLowerCase());
    const descendantMatches = !selfMatches && categoryMatchesSearch(category, searchTerm);
    if (!parentMatches && !selfMatches && !descendantMatches) return null;

    const isExpanded = expandedCategories.has(category.id);
    const isSelected = selectedCategories?.some(sc => String(sc.id) === String(category.id));

    // ── Brand helpers ──────────────────────────────────────────────────
    const brands = category.properties?.brandNames
        ? category.properties.brandNames
              .split(" | ")
              .map((b: string) => b.trim())
              .filter(Boolean)
        : [];
    const BRAND_LIMIT = 3;
    const visibleBrands = showAllBrands ? brands : brands.slice(0, BRAND_LIMIT);
    const overflow = brands.length - BRAND_LIMIT;

    return (
        <>
            <StyledWrapper
                {...styles.categoryItem}
                css={css`
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 11.5px 12px;
                    border-bottom: 1px solid #e0e0e0;
                    padding-left: ${level * 20 + 12}px;
                    cursor: default;
                `}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <StyledWrapper
                    css={css`
                        display: flex;
                        align-items: center;
                        flex: 1;
                        cursor: ${hasChildren ? "pointer" : "default"};
                    `}
                    onClick={() => {
                        if (hasChildren) onToggle(category.id);
                    }}
                >
                    {hasChildren ? (
                        <Button {...styles.categoryToggleButton}>
                            <Icon src={isExpanded ? Minus : Plus} size={24} />
                        </Button>
                    ) : (
                        <span style={{ width: "14px", marginRight: "8px" }} />
                    )}

                    {/* ── Name + brands stacked ── */}
                    <StyledWrapper
                        css={css`
                            display: flex;
                            flex-direction: column;
                            gap: 1px;
                        `}
                    >
                        <Typography>
                            <Link
                                href={category.path}
                                target="_blank"
                                {...styles.categoryNameCustom}
                                css={css`
                                    font-size: ${TYPOGRAPHY.size.smaller};
                                    color: ${isSelected ? "#636161" : COLORS.black} !important;
                                    line-height: 24px;
                                    font-weight: 400;
                                    span {
                                        font-size: ${TYPOGRAPHY.size.smaller};
                                        color: ${isSelected ? "#636161" : COLORS.black} !important;
                                        line-height: 24px;
                                        font-weight: 400;
                                        &:hover {
                                            text-decoration: underline;
                                        }
                                    }
                                `}
                            >
                                {category.name}
                            </Link>
                        </Typography>

                        {/* ── Brand row ── */}
                        {brands.length > 0 && (
                            <StyledWrapper
                                css={css`
                                    display: flex;
                                    align-items: center;
                                    flex-wrap: wrap;
                                    max-width: 400px;
                                `}
                                onClick={e => e.stopPropagation()}
                            >
                                {visibleBrands.map((brand: string, i: number) => (
                                    <span key={i} style={{ display: "inline-flex", alignItems: "center" }}>
                                        <span style={{ fontSize: 11, color: "#6b7280", whiteSpace: "nowrap" }}>
                                            {brand}
                                        </span>
                                        {i < visibleBrands.length - 1 && (
                                            <span style={{ fontSize: 11, color: "#9ca3af", margin: "0 4px" }}>•</span>
                                        )}
                                    </span>
                                ))}

                                {/* +N button */}
                                {!showAllBrands && overflow > 0 && (
                                    <span style={{ display: "inline-flex", alignItems: "center" }}>
                                        <span style={{ fontSize: 11, color: "#9ca3af", margin: "0 4px" }}>•</span>
                                        <button
                                            type="button"
                                            onClick={e => {
                                                e.stopPropagation();
                                                setShowAllBrands(true);
                                            }}
                                            style={{
                                                fontSize: 11,
                                                fontWeight: 600,
                                                color: "#0F96D9",
                                                background: "none",
                                                border: "none",
                                                cursor: "pointer",
                                                padding: 0,
                                                lineHeight: "18px",
                                            }}
                                        >
                                            +{overflow}
                                        </button>
                                    </span>
                                )}

                                {/* less button */}
                                {/* {showAllBrands && overflow > 0 && (
                                    <span style={{ display: "inline-flex", alignItems: "center" }}>
                                        <span style={{ fontSize: 11, color: "#9ca3af", margin: "0 4px" }}>•</span>
                                        <button
                                            type="button"
                                            onClick={e => {
                                                e.stopPropagation();
                                                setShowAllBrands(false);
                                            }}
                                            style={{
                                                fontSize: 11,
                                                fontWeight: 600,
                                                color: "#9ca3af",
                                                background: "none",
                                                border: "none",
                                                cursor: "pointer",
                                                padding: 0,
                                                lineHeight: "18px",
                                            }}
                                        >
                                            {translate("less")}
                                        </button>
                                    </span>
                                )} */}
                            </StyledWrapper>
                        )}
                    </StyledWrapper>
                </StyledWrapper>

                {isSelected ? (
                    <Typography
                        css={css`
                            font-size: 14px;
                            line-height: 24px;
                            font-style: italic;
                            color: #636161;
                            padding: 6px 14px;
                            font-weight: 400;
                            cursor: not-allowed;
                        `}
                    >
                        {translate("Added")}
                    </Typography>
                ) : (
                    <>
                        {isHovered && !hasChildren && (
                            <Button
                                {...styles.addButton}
                                onClick={(e: React.MouseEvent) => {
                                    e.stopPropagation();
                                    onAdd(category);
                                }}
                            >
                                {translate("Quick Add")}
                            </Button>
                        )}
                    </>
                )}
            </StyledWrapper>

            {hasChildren &&
                isExpanded &&
                category.subCategories.map((subCat: any) => (
                    <CategoryItem
                        key={subCat.id}
                        category={subCat}
                        level={level + 1}
                        searchTerm={searchTerm}
                        expandedCategories={expandedCategories}
                        selectedCategories={selectedCategories}
                        onToggle={onToggle}
                        onAdd={onAdd}
                        categoryMatchesSearch={categoryMatchesSearch}
                        parentMatches={selfMatches}
                    />
                ))}
        </>
    );
};

const CategorySelector = ({
    getCategoriesParameter,
    postTaxonomyData,
    addTaxonomyCatHandler,
    getTaxonomyRecommendationHandler,
    getTaxonomyCategoryByIdHandler,
    patchTaxonomyCategoryHandler,
    exportTaxonomyRecommendationHandler,
    session,
}: Props) => {
    const toasterContext = useContext(ToasterContext);
    const [taxonomyCategories, setTaxonomyCategories] = useState<any>([]);
    const [catHierarchy, setCatHierarchy] = useState<any>([]);
    const [taxonomyRecommendationModels, setTaxonomyRecommendationModels] = useState<TaxonomyRecommendationModel[]>([]);
    const [showListView, setShowListView] = useState(true);
    const [selectedCatView, setSlectedCatView] = useState(false);
    const [path, setPath] = useState<any>();
    const [sort, setSort] = useState("");
    const [sortField, setSortField] = useState("");
    const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");
    const [selectedCategories, setSelectedCategories] = useState<SelectedCategory[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [editId, setEditId] = useState<string>("");
    const [searchSourceCategoryName, setSearchSourceCategoryName] = useState<string>("");
    const debounceRef = useRef<NodeJS.Timeout | null>(null);
    const searchChanged = useRef(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [hasPerformedSearch, setHasPerformedSearch] = useState(false);
    const [hoveredRowId, setHoveredRowId] = useState<string | null>(null);
    const [showLimitModal, setShowLimitModal] = useState(false);
    const categoryById: any = {};
    const isFreshState = !isLoading && taxonomyRecommendationModels.length === 0 && searchSourceCategoryName === "";
    const [expandedBrandRows, setExpandedBrandRows] = useState<Set<string>>(new Set());

    const toggleBrands = (id: string) => {
        setExpandedBrandRows(prev => {
            const next = new Set(prev);
            next.has(id) ? next.delete(id) : next.add(id);
            return next;
        });
    };

    useEffect(() => {
        postTaxonomyData({
            ...getCategoriesParameter,
            onSuccess: (result: any) => {
                setTaxonomyCategories(result);
            },
        });
    }, []);

    const handleSort = (field: string) => {
        if (sortField === field) {
            setSortDirection(sortDirection === "asc" ? "desc" : "asc");
        } else {
            setSortField(field);
            setSortDirection("asc");
        }
    };

    const performSearch = useCallback(
        (isInitialLoad = false) => {
            isInitialLoad ? setIsLoading(true) : setIsTableLoading(true);
            const sortParam = sortField ? `${sortField} ${sortDirection}` : "";
            const params: any = {
                Page: 1,
                PageSize: 1000,
                onSuccess: (result: any) => {
                    setTaxonomyRecommendationModels(result.taxonomyRecommendationModels);
                    setIsLoading(false);
                    setIsTableLoading(false);
                    searchSourceCategoryName ? setHasPerformedSearch(true) : setHasPerformedSearch(false);
                },
                onError: (error: string) => {
                    setIsLoading(false);
                    setIsTableLoading(false);
                    searchSourceCategoryName ? setHasPerformedSearch(true) : setHasPerformedSearch(false);
                },
            };
            if (sortParam) params.Sort = sortParam;
            if (searchSourceCategoryName) params.query = searchSourceCategoryName;
            getTaxonomyRecommendationHandler(params);
        },
        [sortField, sortDirection, searchSourceCategoryName, getTaxonomyRecommendationHandler],
    );

    const debouncedPerformSearch = useCallback(
        debounce(() => {
            if (searchSourceCategoryName.length === 0 || searchSourceCategoryName.length > 2) {
                performSearch();
            }
        }, 2000),
        [performSearch],
    );

    useEffect(() => {
        if (isFreshState && !hasPerformedSearch) {
            setShowListView(false);
            setShowDropdown(true);
            setSlectedCatView(true);
        }
    }, [isFreshState, hasPerformedSearch]);

    useEffect(() => {
        // first mount: no sortField/sortDirection yet, so this IS the initial load
        performSearch(sortField === "" && sortDirection === "asc" && !hasPerformedSearch);
    }, [sortField, sortDirection]);

    const hasSMERole = /\bCentro_SME\b/.test(session?.userRoles);

    useEffect(() => {
        if (!hasSMERole) {
            window.location.href = "/";
        }
    }, [session]);

    if (!hasSMERole) return null;

    useEffect(() => {
        if (searchChanged.current) {
            if (searchSourceCategoryName.length === 0) {
                performSearch();
            } else {
                debouncedPerformSearch();
            }
        }
    }, [searchSourceCategoryName, debouncedPerformSearch, performSearch]);

    const editClick = (item: any) => {
        const hierarchy = getHierarchy(item.sourceTaxonomyId);
        setCatHierarchy(hierarchy);
        const path = findCategoryPath(categoriessCustom.categories, item.sourceTaxonomyId) || [];
        setPath(path);
        setSourceCategoryPath(["Home", ...path]);
        setEditId(item.id);

        getTaxonomyCategoryByIdHandler({
            id: item.id,
            onSuccess: (result: any) => {
                setSelectedSourceCategory(result.sourceTaxonomyId);
                setSelectedCategories(
                    result.relatedTaxonomies.map((rt: any) => ({
                        id: rt.targetTaxonomyId,
                        targetTaxonomyName: rt.targetTaxonomyName,
                    })),
                );

                const newExpanded = new Set(expandedCategories);
                let current = categoryById[item.sourceTaxonomyId];
                while (current) {
                    newExpanded.add(current.id);
                    if (!current.parentId) break;
                    current = categoryById[current.parentId];
                }
                result.relatedTaxonomies.forEach((related: any) => {
                    let current = categoryById[related.targetTaxonomyId];
                    while (current) {
                        newExpanded.add(current.id);
                        if (!current.parentId) break;
                        current = categoryById[current.parentId];
                    }
                });
                setExpandedCategories(newExpanded);
            },
            onError: (error: string) => {},
        });
        setShowListView(false);
        setShowDropdown(false);
        setSlectedCatView(true);
        setEditId(item.id);
    };

    const handleSave = (e: React.MouseEvent) => {
        if (!selectedSourceCategory) return;

        const payload = {
            id: editId && editId ? editId : "",
            sourceTaxonomyId: editId && editId ? selectedSourceCategory : selectedSourceCategory.id,
            relatedTaxonomies: selectedCategories?.map((cat, index) => ({
                id: cat.id,
                targetTaxonomyId: cat.id,
                priority: index + 1,
            })),
            onSuccess: (result: any) => {
                toasterContext.addToast({
                    body: translate("Taxonomy category saved successfully."),
                    messageType: "success",
                });
                setTimeout(() => {
                    setShowListView(true);
                    setSelectedSourceCategory(null);
                    setSelectedCategories([]);
                    setCatHierarchy([]);
                    setSlectedCatView(false);
                    setEditId("");
                    setExpandedCategories(new Set<string>());
                    setSearchTerm("");
                    setSourceCategoryPath([]);
                    setShowDropdown(true);
                    performSearch();
                    setDropdownSearchTerm("");
                }, 2000);
            },
            onError: (error: string) => {},
        };

        editId ? patchTaxonomyCategoryHandler(payload) : addTaxonomyCatHandler(payload);
    };

    const handleCancel = () => {
        setShowListView(true);
        setSelectedSourceCategory(null);
        setSelectedCategories([]);
        setCatHierarchy([]);
        setSlectedCatView(false);
        setEditId("");
        setExpandedCategories(new Set<string>());
        setSearchTerm("");
        setSourceCategoryPath([]);
        setShowDropdown(false);
    };

    const getAllCategories = (categories: any[], level = 0) => {
        let result: any[] = [];
        categories.forEach(category => {
            result.push({ ...category, level });
            if (Array.isArray(category.subCategories)) {
                result.push(...getAllCategories(category.subCategories, level + 1));
            }
        });
        return result;
    };

    const categoriess = getAllCategories(taxonomyCategories.categories ?? []);
    const categoriessCustom = taxonomyCategories.categories ?? [];

    categoriess.forEach(cat => {
        categoryById[cat.id] = cat;
    });

    const getHierarchy = (leafId?: string) => {
        if (!leafId || !categoryById[leafId]) return [];
        const result: { name: string; path: string }[] = [];
        let current = categoryById[leafId];
        while (current && typeof current === "object") {
            result.unshift({ name: String(current.name), path: String(current.path || "") });
            if (!current.parentId) break;
            current = categoryById[current.parentId];
        }
        return result;
    };

    const [searchTerm, setSearchTerm] = useState("");
    const [dropdownSearchTerm, setDropdownSearchTerm] = useState("");

    // Single source of truth: which category IDs are currently expanded.
    // Populated by: search auto-expand, edit/load, and manual user clicks.
    const [expandedCategories, setExpandedCategories] = useState(new Set<string>());

    const [draggedItem, setDraggedItem] = useState<number | null>(null);
    const [showDropdown, setShowDropdown] = useState(true);
    const [selectedSourceCategory, setSelectedSourceCategory] = useState<any>(null);
    const [sourceCategoryPath, setSourceCategoryPath] = useState<string[]>([]);

    const dropdownRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                const target = event.target as HTMLElement;
                const rect = target.getBoundingClientRect();
                const scrollbarWidth = 17;
                const isVerticalScrollbar = event.clientX >= rect.right - scrollbarWidth;
                const isHorizontalScrollbar = event.clientY >= rect.bottom - scrollbarWidth;
                if (!isVerticalScrollbar && !isHorizontalScrollbar) {
                    setShowDropdown(false);
                }
            }
        };
        if (showDropdown) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showDropdown]);

    // Helper: collect all ancestor IDs of nodes that match the search
    const getAncestorIdsForSearch = (cats: any[], search: string, ancestors: string[] = []): string[] => {
        let result: string[] = [];
        for (const cat of cats) {
            const selfMatches = cat.name.toLowerCase().includes(search.toLowerCase());
            const childAncestors = cat.subCategories?.length
                ? getAncestorIdsForSearch(cat.subCategories, search, [...ancestors, cat.id])
                : [];

            // If this node itself matches, expand all its ancestors so it is visible
            if (selfMatches) {
                result.push(...ancestors);
            }
            // Also include ancestors found deeper in the tree
            result.push(...childAncestors);

            // If self matches AND has children, also expand self to show children
            if (selfMatches && cat.subCategories?.length) {
                result.push(cat.id);
            }
        }
        return result;
    };

    // When searchTerm changes: replace expandedCategories with exactly the auto-expand set.
    // This resets any previous state cleanly — user can then click to toggle from this base.
    useEffect(() => {
        if (!searchTerm.trim()) {
            setExpandedCategories(new Set<string>());
            return;
        }
        const toExpand = getAncestorIdsForSearch(categoriessCustom, searchTerm);
        setExpandedCategories(new Set(toExpand));
    }, [searchTerm]);

    useEffect(() => {
        if (!dropdownSearchTerm.trim()) {
            setExpandedCategories(new Set<string>());
            return;
        }
        const toExpand = getAncestorIdsForSearch(categoriessCustom, dropdownSearchTerm);
        setExpandedCategories(new Set(toExpand));
    }, [dropdownSearchTerm]);

    // Simple toggle — always just flip the ID in the Set.
    // Works for both search and non-search contexts.
    const toggleCategory = (id: string) => {
        setExpandedCategories(prev => {
            const next = new Set(prev);
            if (next.has(id)) {
                next.delete(id);
            } else {
                next.add(id);
            }
            return next;
        });
    };

    const handleDragStart = (e: React.DragEvent, index: number) => {
        setDraggedItem(index);
        e.dataTransfer.effectAllowed = "move";
    };

    const handleDragOver = (e: React.DragEvent, index: number) => {
        e.preventDefault();
        if (draggedItem === null || draggedItem === index) return;
        const newCategories = [...selectedCategories];
        const draggedCategory = newCategories[draggedItem];
        newCategories.splice(draggedItem, 1);
        newCategories.splice(index, 0, draggedCategory);
        setSelectedCategories(newCategories);
        setDraggedItem(index);
    };

    const handleDragEnd = () => setDraggedItem(null);

    const removeCategory = (id: string) => {
        setSelectedCategories(selectedCategories?.filter(cat => cat.id !== id));
    };

    const addCategory = (category: any) => {
        const isAlreadyAdded = selectedCategories?.some(cat => cat.id === category.id);
        if (!isAlreadyAdded) {
            if (selectedCategories.length >= 10) {
                setShowLimitModal(true);
            } else {
                setSelectedCategories([...selectedCategories, { id: category.id, targetTaxonomyName: category.name }]);
            }
        }
    };

    const categoryMatchesSearch = (category: any, search: string): boolean => {
        if (!search.trim()) return true;
        const matches = category.name.toLowerCase().includes(search.toLowerCase());
        if (matches) return true;
        if (category.subCategories && category.subCategories.length > 0) {
            return category.subCategories.some((child: any) => categoryMatchesSearch(child, search));
        }
        return false;
    };

    const findCategoryPath = (categories: any, targetId: number, path: string[] = []): string[] | null => {
        if (!Array.isArray(categories)) return null;
        for (const category of categories) {
            const currentPath = [...path, category.name];
            if (String(category.id) === String(targetId)) return currentPath;
            if (category.subcategories?.length) {
                const found = findCategoryPath(category.subcategories, targetId, currentPath);
                if (found) return found;
            }
        }
        return null;
    };

    const handleSourceCategorySelect = (category: any) => {
        setSelectedSourceCategory(category);
        const hierarchy = getHierarchy(category.id);
        setCatHierarchy(hierarchy);
        const path = findCategoryPath(categoriessCustom.categories, category.id) || [];
        setPath(path);
        setSourceCategoryPath(["Home", ...path]);
        setShowDropdown(false);
    };

    const hasAnyCategoryMatch = (categories: any[], search: string): boolean => {
        if (!search.trim()) return true;
        return categories.some(category => categoryMatchesSearch(category, search));
    };

    const selectedCategoryName = catHierarchy?.length > 0 ? catHierarchy[catHierarchy.length - 1].name : "";
    const [isBreadcrumbOpen, setIsBreadcrumbOpen] = useState(true);

    useEffect(() => {
        if (selectedSourceCategory && selectedCatView) setIsBreadcrumbOpen(true);
    }, [selectedSourceCategory, selectedCatView]);

    useEffect(() => {
        if (showDropdown) setIsBreadcrumbOpen(false);
    }, [showDropdown]);

    const taxonomyListView = () => {
        return (
            <StyledWrapper {...styles.sectionContainer}>
                <Typography {...styles.pageTitle}>{translate("Category Relationships")}</Typography>
                <StyledWrapper
                    css={css`
                        display: flex;
                        align-items: center;
                        margin-bottom: 16px;
                        justify-content: space-between;
                        @media (max-width: 768px) {
                            gap: 8px;
                            flex-direction: column;
                        }
                    `}
                >
                    <StyledWrapper {...styles.serachWrapper}>
                        <TextField
                            value={searchSourceCategoryName}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setSearchSourceCategoryName(e.target.value);
                                searchChanged.current = true;
                            }}
                            placeholder="Search Source Category Name"
                        />
                    </StyledWrapper>
                    <StyledWrapper
                        css={css`
                            display: flex;
                            gap: 12px;
                            @media (max-width: 819px) {
                                width: 100%;
                            }
                        `}
                    >
                        <Button variant="secondary" onClick={() => exportTaxonomyRecommendationHandler({})}>
                            {translate("Export Category Relationships")}
                        </Button>
                        <Button
                            variant="secondary"
                            onClick={() => {
                                setShowListView(false);
                                setShowDropdown(true);
                                setSlectedCatView(true);
                            }}
                        >
                            {translate("Add Source Category ")}
                        </Button>
                    </StyledWrapper>
                </StyledWrapper>
                {isTableLoading ? (
                    <StyledWrapper {...styles.centeringWrapper}>
                        <LoadingSpinner {...styles.spinner} />
                    </StyledWrapper>
                ) : taxonomyRecommendationModels.length > 0 ? (
                    <StyledWrapper {...styles.tableScrollWrapper}>
                        <DataTable {...styles.dataTable}>
                            <DataTableHead>
                                <DataTableHeader
                                    {...styles.sourceCategoryNameHeader}
                                    onSortClick={() => handleSort("sourceTaxonomyName")}
                                    sorted={
                                        sortField === "sourceTaxonomyName"
                                            ? sortDirection === "asc"
                                                ? "ascending"
                                                : "descending"
                                            : false
                                    }
                                >
                                    {translate("Source Category Name")}
                                </DataTableHeader>
                                <DataTableHeader
                                    {...styles.modifiedByHeader}
                                    onSortClick={() => handleSort("modifiedBy")}
                                    sorted={
                                        sortField === "modifiedBy"
                                            ? sortDirection === "asc"
                                                ? "ascending"
                                                : "descending"
                                            : false
                                    }
                                >
                                    {translate("Modified By")}
                                </DataTableHeader>
                                <DataTableHeader
                                    {...styles.modifiedOnHeader}
                                    onSortClick={() => handleSort("modifiedOn")}
                                    sorted={
                                        sortField === "modifiedOn"
                                            ? sortDirection === "asc"
                                                ? "ascending"
                                                : "descending"
                                            : false
                                    }
                                >
                                    {translate("Modified On")}
                                </DataTableHeader>
                                <DataTableHeader
                                    {...styles.createdByHeader}
                                    onSortClick={() => handleSort("createdBy")}
                                    sorted={
                                        sortField === "createdBy"
                                            ? sortDirection === "asc"
                                                ? "ascending"
                                                : "descending"
                                            : false
                                    }
                                >
                                    {translate("Created By")}
                                </DataTableHeader>
                                <DataTableHeader
                                    {...styles.createdOnHeader}
                                    onSortClick={() => handleSort("createdOn")}
                                    sorted={
                                        sortField === "createdOn"
                                            ? sortDirection === "asc"
                                                ? "ascending"
                                                : "descending"
                                            : false
                                    }
                                >
                                    {translate("Created On")}
                                </DataTableHeader>
                                <DataTableHeader {...styles.editHeader}>{translate("Edit")}</DataTableHeader>
                            </DataTableHead>
                            <DataTableBody>
                                {taxonomyRecommendationModels.map((item: any, index: number) => (
                                    <DataTableRow
                                        key={item.id || index}
                                        onMouseEnter={() => setHoveredRowId(item.id)}
                                        onMouseLeave={() => setHoveredRowId(null)}
                                    >
                                        <DataTableCell {...styles.sourceCategoryNameCells}>
                                            {/* Category name (with optional bold highlight) */}
                                            {searchSourceCategoryName
                                                ? getBoldedText(item.sourceTaxonomyName || "", searchSourceCategoryName)
                                                : item.sourceTaxonomyName || ""}

                                            {/* Brand chips */}
                                            {item.brandNames &&
                                                (() => {
                                                    const brands = item.brandNames
                                                        .split(" | ")
                                                        .map((b: string) => b.trim())
                                                        .filter(Boolean);
                                                    const isExpanded = expandedBrandRows.has(item.id);
                                                    const LIMIT = 3;
                                                    const visible = isExpanded ? brands : brands.slice(0, LIMIT);
                                                    const overflow = brands.length - LIMIT;

                                                    return (
                                                        <StyledWrapper
                                                            style={{
                                                                display: "flex",
                                                                flexWrap: "wrap",
                                                                alignItems: "center",
                                                                maxWidth: 315,
                                                                marginTop: 4,
                                                            }}
                                                        >
                                                            {visible.map((brand: string, i: number) => (
                                                                <span
                                                                    key={i}
                                                                    style={{
                                                                        display: "inline-flex",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    <span
                                                                        style={{
                                                                            fontSize: 11,
                                                                            color: "#6b7280",
                                                                            whiteSpace: "nowrap",
                                                                        }}
                                                                    >
                                                                        {brand}
                                                                    </span>
                                                                    {i < visible.length - 1 && (
                                                                        <span
                                                                            style={{
                                                                                fontSize: 11,
                                                                                color: "#9ca3af",
                                                                                margin: "0 3px",
                                                                            }}
                                                                        >
                                                                            •
                                                                        </span>
                                                                    )}
                                                                </span>
                                                            ))}

                                                            {/* +N expand button */}
                                                            {!isExpanded && overflow > 0 && (
                                                                <button
                                                                    type="button"
                                                                    onClick={e => {
                                                                        e.stopPropagation();
                                                                        toggleBrands(item.id);
                                                                    }}
                                                                    style={{
                                                                        fontSize: 11,
                                                                        fontWeight: 600,
                                                                        color: "#0F96D9",
                                                                        background: "none",
                                                                        border: "none",
                                                                        cursor: "pointer",
                                                                        padding: "1px 4px",
                                                                        borderRadius: 4,
                                                                    }}
                                                                >
                                                                    +{overflow}
                                                                </button>
                                                            )}

                                                            {/* Collapse button when expanded */}
                                                            {/* {isExpanded && overflow > 0 && (
                                                                <button
                                                                    type="button"
                                                                    onClick={e => {
                                                                        e.stopPropagation();
                                                                        toggleBrands(item.id);
                                                                    }}
                                                                    style={{
                                                                        fontSize: 11,
                                                                        fontWeight: 600,
                                                                        color: "#9ca3af",
                                                                        background: "none",
                                                                        border: "none",
                                                                        cursor: "pointer",
                                                                        padding: "1px 4px",
                                                                    }}
                                                                >
                                                                    {translate("less")}
                                                                </button>
                                                            )} */}
                                                        </StyledWrapper>
                                                    );
                                                })()}
                                        </DataTableCell>
                                        <DataTableCell {...styles.modifiedByCells}>
                                            {searchSourceCategoryName
                                                ? getBoldedText(item.modifiedBy || "", searchSourceCategoryName)
                                                : item.modifiedBy || ""}
                                        </DataTableCell>
                                        <DataTableCell {...styles.modifiedOnCells}>
                                            {getLocalizedDateTime({ dateTime: new Date(item.modifiedOn) })}
                                        </DataTableCell>
                                        <DataTableCell {...styles.createdByCells}>
                                            {searchSourceCategoryName
                                                ? getBoldedText(item.createdBy || "", searchSourceCategoryName)
                                                : item.createdBy || ""}
                                        </DataTableCell>
                                        <DataTableCell {...styles.createdOnCells}>
                                            {getLocalizedDateTime({ dateTime: new Date(item.createdOn) })}
                                        </DataTableCell>
                                        <DataTableCell {...styles.editCells}>
                                            {hoveredRowId === item.id && (
                                                <Button buttonType="outline" onClick={() => editClick(item)}>
                                                    {translate("Manage")}
                                                </Button>
                                            )}
                                        </DataTableCell>
                                    </DataTableRow>
                                ))}
                            </DataTableBody>
                        </DataTable>
                    </StyledWrapper>
                ) : hasPerformedSearch ? (
                    <StyledWrapper {...styles.centeringWrapper}>
                        <Typography {...styles.pageSubtitle}>{translate("No results found")}</Typography>
                    </StyledWrapper>
                ) : null}
            </StyledWrapper>
        );
    };

    return (
        <StyledWrapper {...styles.mainContainer}>
            <StyledWrapper
                css={css`
                    max-width: 1800px;
                    margin: 0 auto;
                    position: relative;
                `}
                ref={dropdownRef as any}
            >
                <StyledWrapper {...styles.sectionContainer}>
                    <Typography {...styles.pageTitle}>{translate("Taxonomy Portal")}</Typography>
                    {showListView && (
                        <Typography {...styles.pageSubtitle}>
                            {translate("Manage related category relationships across the catalog.")}
                        </Typography>
                    )}
                </StyledWrapper>

                {showListView && !isFreshState ? (
                    isLoading ? (
                        <StyledWrapper {...styles.centeringWrapper}>
                            <LoadingSpinner {...styles.spinner} />
                        </StyledWrapper>
                    ) : (
                        taxonomyListView()
                    )
                ) : (
                    <StyledWrapper {...styles.sectionContainerTwo}>
                        <StyledWrapper
                            css={css`
                                display: flex;
                                align-items: center;
                                margin-bottom: 16px;
                            `}
                        >
                            <Typography {...styles.headerNumber}>1</Typography>
                            <Typography {...styles.headerTitle}>{translate("Select Source Category")}</Typography>
                        </StyledWrapper>
                        <StyledWrapper
                            css={css`
                                position: relative;
                            `}
                            ref={dropdownRef as any}
                        >
                            {!selectedSourceCategory && (
                                <Button {...styles.selectCategoryButton} onClick={() => setShowDropdown(prev => !prev)}>
                                    {translate("Select Category")}
                                    {showDropdown ? (
                                        <Icon src={CENTaxonomyArrowUp} />
                                    ) : (
                                        <Icon src={CENTaxonomyArrowDown} />
                                    )}
                                </Button>
                            )}

                            {showDropdown && (
                                <StyledWrapper
                                    css={css`
                                        border: 1px solid #eef3f0;
                                        padding: 24px;
                                        overflow-y: auto;
                                        height: 500px;
                                        display: flex;
                                        flex-direction: column;
                                        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                                        z-index: 1000;
                                        background-color: ${COLORS.white};
                                        input {
                                            font-size: ${TYPOGRAPHY.size.smaller} !important;
                                            line-height: 24px !important;
                                            font-weight: 400 !important;
                                            padding: 12px 24px !important;
                                            border-radius: 32px !important;
                                            background-color: #f2f2f2 !important;
                                            margin-bottom: 16px;
                                            height: 48px !important;
                                        }
                                    `}
                                >
                                    <StyledWrapper
                                        css={css`
                                            flex-shrink: 0;
                                            border-bottom: 1px solid #e0e0e0;
                                        `}
                                    >
                                        <TextField
                                            placeholder={translate("Search categories")}
                                            value={dropdownSearchTerm}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                setDropdownSearchTerm(e.target.value)
                                            }
                                            iconProps={{ ...styles.icon, src: CENTaxonomySearchIcon }}
                                            cssOverrides={{
                                                formInputWrapper: css`
                                                    && > input {
                                                        font-size: ${TYPOGRAPHY.size.smaller};
                                                        line-height: 24px;
                                                        font-weight: 400;
                                                        padding: 12px 24px;
                                                        border-radius: 32px;
                                                        background-color: #f2f2f2;
                                                        height: 48px;
                                                    }
                                                `,
                                            }}
                                        />
                                    </StyledWrapper>

                                    <StyledWrapper
                                        css={css`
                                            flex: 1;
                                            overflow-y: auto;
                                            border: 1px solid #e0dfe0;
                                        `}
                                    >
                                        {hasAnyCategoryMatch(categoriessCustom, dropdownSearchTerm) ? (
                                            categoriessCustom?.map((category: any) => (
                                                <DropdownCategoryItem
                                                    key={category.id}
                                                    category={category}
                                                    dropdownSearchTerm={dropdownSearchTerm}
                                                    expandedCategories={expandedCategories}
                                                    selectedSourceCategory={selectedSourceCategory}
                                                    taxonomyRecommendationModels={taxonomyRecommendationModels}
                                                    onToggle={toggleCategory}
                                                    onSelect={handleSourceCategorySelect}
                                                    categoryMatchesSearch={categoryMatchesSearch}
                                                />
                                            ))
                                        ) : (
                                            <StyledWrapper {...styles.noCategoryWrapper}>
                                                <Typography {...styles.noCategoryText}>
                                                    {translate("No categories found")}
                                                </Typography>
                                            </StyledWrapper>
                                        )}
                                    </StyledWrapper>
                                </StyledWrapper>
                            )}

                            {selectedSourceCategory && selectedCatView && !showDropdown && (
                                <StyledWrapper {...styles.headerSection}>
                                    <StyledWrapper {...styles.selectedCategoryBox}>
                                        <Typography {...styles.selectedCategoryText}>
                                            {selectedCategoryName}
                                            <Typography
                                                onClick={(e: React.MouseEvent<HTMLElement>) => {
                                                    e.stopPropagation();
                                                    setIsBreadcrumbOpen(prev => !prev);
                                                }}
                                                css={css`
                                                    display: inline-flex;
                                                    align-items: center;
                                                    margin-left: 8px;
                                                    cursor: pointer;
                                                `}
                                            >
                                                <Icon
                                                    src={isBreadcrumbOpen ? CENTaxonomyArrowUp : CENTaxonomyArrowDown}
                                                    size={24}
                                                />
                                            </Typography>
                                        </Typography>

                                        {isBreadcrumbOpen && (
                                            <Typography {...styles.breadcrumbText} as="p">
                                                <a href="/">Home</a>
                                                {catHierarchy.slice(0, -1).map((cat: any, index: number) => (
                                                    <span key={cat.path ?? index}>
                                                        {" | "}
                                                        <a href={cat.path}>{cat.name}</a>
                                                    </span>
                                                ))}
                                            </Typography>
                                        )}
                                    </StyledWrapper>

                                    <Button
                                        {...styles.changeButton}
                                        onClick={() => {
                                            setIsBreadcrumbOpen(false);
                                            setShowDropdown(true);
                                            setSelectedSourceCategory(null);
                                        }}
                                        disabled={!!editId}
                                    >
                                        {translate("Change")}
                                    </Button>
                                </StyledWrapper>
                            )}
                        </StyledWrapper>
                    </StyledWrapper>
                )}

                {selectedSourceCategory && !showDropdown && (
                    <>
                        <StyledWrapper {...styles.gridContainer}>
                            {/* Left Panel */}
                            <StyledWrapper>
                                <StyledWrapper
                                    css={css`
                                        display: flex;
                                        align-items: center;
                                        margin-bottom: 16px;
                                    `}
                                >
                                    <StyledWrapper {...styles.headerSectionWrapper}>
                                        <StyledWrapper {...styles.headerSubHeading}>
                                            <Typography {...styles.headerNumber}>2</Typography>
                                            <Typography {...styles.headerTitleCustom}>
                                                {translate("Add Related Categories")}
                                            </Typography>
                                        </StyledWrapper>
                                        <Typography {...styles.headerDescription}>
                                            {translate(
                                                "Categories are added individually. Subcategories are not added automatically.",
                                            )}
                                        </Typography>
                                    </StyledWrapper>
                                </StyledWrapper>
                                <StyledWrapper {...styles.panelContainer}>
                                    <StyledWrapper {...styles.panelHeader}>
                                        <TextField
                                            {...styles.searchField}
                                            placeholder={translate("Search categories")}
                                            value={searchTerm}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                setSearchTerm(e.target.value)
                                            }
                                            iconProps={{ ...styles.iconTwo, src: CENTaxonomySearchIcon }}
                                        />
                                    </StyledWrapper>

                                    <StyledWrapper {...styles.categoryListContainer}>
                                        {hasAnyCategoryMatch(categoriessCustom, searchTerm) ? (
                                            categoriessCustom.map((category: any) => (
                                                <CategoryItem
                                                    key={category.id}
                                                    category={category}
                                                    searchTerm={searchTerm}
                                                    expandedCategories={expandedCategories}
                                                    selectedCategories={selectedCategories}
                                                    onToggle={toggleCategory}
                                                    onAdd={addCategory}
                                                    categoryMatchesSearch={categoryMatchesSearch}
                                                />
                                            ))
                                        ) : (
                                            <StyledWrapper {...styles.noCategoryWrapper}>
                                                <Typography {...styles.noCategoryText}>
                                                    {translate("No related categories found")}
                                                </Typography>
                                            </StyledWrapper>
                                        )}
                                    </StyledWrapper>
                                </StyledWrapper>
                            </StyledWrapper>

                            {/* Right Panel */}
                            <StyledWrapper>
                                <StyledWrapper
                                    css={css`
                                        display: flex;
                                        align-items: center;
                                        margin-bottom: 16px;
                                    `}
                                >
                                    <StyledWrapper {...styles.headerSectionWrapper}>
                                        <StyledWrapper {...styles.headerSubHeading}>
                                            <Typography {...styles.headerNumber}>3</Typography>
                                            <Typography {...styles.headerTitleCustom}>
                                                {translate("Reorder Related Categories")}
                                            </Typography>
                                        </StyledWrapper>
                                        <Typography {...styles.headerDescription}>
                                            {translate("Drag categories to set their display order.")}
                                        </Typography>
                                    </StyledWrapper>
                                </StyledWrapper>

                                <StyledWrapper {...styles.panelContainer}>
                                    <StyledWrapper {...styles.panelHeaderTwo}>
                                        <Typography
                                            css={css`
                                                font-size: ${TYPOGRAPHY.size.smaller};
                                                font-weight: 600;
                                                line-height: 24px;
                                                color: #636161;
                                            `}
                                        >
                                            {selectedCategories.length > 0
                                                ? `${selectedCategories.length} ${translate("Related Categories")}`
                                                : translate("Related Categories")}
                                        </Typography>
                                    </StyledWrapper>

                                    {selectedCategories.length === 0 ? (
                                        <StyledWrapper
                                            css={css`
                                                display: flex;
                                                background-color: ${COLORS.white};
                                                max-height: 491px;
                                                min-height: 491px;
                                            `}
                                        >
                                            <Typography
                                                css={css`
                                                    font-size: 14px;
                                                    line-height: 24px;
                                                    color: #262525;
                                                    text-align: center;
                                                    margin-top: 64px;
                                                    margin-left: auto;
                                                    margin-right: auto;
                                                `}
                                            >
                                                {translate(
                                                    "Select categories from the column at left to start reordering.",
                                                )}
                                            </Typography>
                                        </StyledWrapper>
                                    ) : (
                                        <StyledWrapper {...styles.categoryListContainer}>
                                            {selectedCategories.map((category, index) => (
                                                <StyledWrapper
                                                    key={category.id}
                                                    draggable
                                                    onDragStart={e => handleDragStart(e, index)}
                                                    onDragOver={e => handleDragOver(e, index)}
                                                    onDragEnd={handleDragEnd}
                                                    css={css`
                                                        display: flex;
                                                        align-items: center;
                                                        justify-content: space-between;
                                                        padding: 24px;
                                                        border-bottom: 1px solid #e0dfe0;
                                                        background-color: ${COLORS.white};
                                                        cursor: pointer;
                                                        opacity: ${draggedItem === index ? 0.6 : 1};
                                                        &:active {
                                                            cursor: grabbing;
                                                        }
                                                        &:hover {
                                                            background-color: #eef3f0;
                                                            span {
                                                                font-weight: 600;
                                                            }
                                                        }
                                                    `}
                                                >
                                                    <StyledWrapper
                                                        css={css`
                                                            display: flex;
                                                            align-items: center;
                                                        `}
                                                    >
                                                        <StyledWrapper {...styles.dragHandle}>
                                                            <Icon src={CENTaxonomyTwoLineMenu} size={16} />
                                                        </StyledWrapper>
                                                        <Typography {...styles.categoryName}>
                                                            {category.targetTaxonomyName}
                                                        </Typography>
                                                    </StyledWrapper>
                                                    <Button
                                                        {...styles.removeButton}
                                                        onClick={() => removeCategory(category.id)}
                                                    >
                                                        {translate("Remove")}
                                                    </Button>
                                                </StyledWrapper>
                                            ))}
                                        </StyledWrapper>
                                    )}
                                </StyledWrapper>
                            </StyledWrapper>
                        </StyledWrapper>
                    </>
                )}

                <StyledWrapper {...styles.footerButtons}>
                    {!showListView && (
                        <Button {...styles.cancelButton} onClick={handleCancel}>
                            {translate("Cancel")}
                        </Button>
                    )}
                    {selectedSourceCategory && !showDropdown && (
                        <Button {...styles.saveButton} onClick={handleSave} disabled={!selectedCategories.length}>
                            {translate("Save Changes")}
                        </Button>
                    )}
                </StyledWrapper>

                <Modal
                    headline={translate("Limit Reached")}
                    isOpen={showLimitModal}
                    handleClose={() => setShowLimitModal(false)}
                >
                    <Typography>{translate("You can add only 10 related categories.")}</Typography>
                </Modal>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CategorySelector),
    definition: {
        group: "Basic",
        displayName: "CEN Taxonomy Widget",
    },
};

export default widgetModule;
